export default __webpack_public_path__ + "static/media/SG.763865e4.svg";